import React from "react"
import { Grid } from "@mui/material"

import GridViewItem from "components/Algolia/Results/GridViewItem"
import LockingSystemGridViewItem from "./LockingSystem/LockingSystemGridViewItem"

import { AlgoliaLockingSystemHit, AlgoliaProductHit } from "@secureo/common/typings/Algolia"
import { AlgoliaUIPageType } from "../AlgoliaSearchUI"

const GridView = ({ hits, locale, categoryName, pageType }: Props) => {
	if (hits.length === 0) return null

	const isLockingSystem = pageType === "locking-systems"

	return (
		<Grid container spacing={2}>
			{hits.map((hit, position) => {
				return (
					<Grid item xs={12} sm={6} md={4} lg={3} key={hit.objectID}>
						{isLockingSystem ? (
							<LockingSystemGridViewItem
								hit={hit as AlgoliaLockingSystemHit}
								locale={locale}
								position={position + 1}
								categoryName={categoryName}
							/>
						) : (
							<GridViewItem
								hit={hit as AlgoliaProductHit}
								locale={locale}
								position={position + 1}
								categoryName={categoryName}
							/>
						)}
					</Grid>
				)
			})}
		</Grid>
	)
}

interface Props {
	hits: (AlgoliaProductHit | AlgoliaLockingSystemHit)[]
	locale: string
	categoryName: string
	pageType?: AlgoliaUIPageType
}

export default GridView
